import {
    mapActions,
    mapMutations
} from 'vuex';

export default {
    methods: {
        ...mapMutations({
            _setState: 'orders/setState',
            _setList: 'orders/setList',
            _addToList: 'orders/addToList',
            _clearOrders: 'orders/clearOrders'
        }),
        ...mapActions({
            _fetch: 'orders/fetch'
        }),
        async fetchOrdersMixin(key = 'set') {
            key = key === 'add' ? '_addToList' : '_setList';

            if (key === '_setList') {
                this._clearOrders();
            }

            const {
                data,
                meta
            } = await this._fetch();

            this._setState({
                key: 'meta',
                value: meta
            });

            this[key](data);
        }
    }
}